import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import styled from "styled-components"

import Month from "../elements/Month"
import Block from "../elements/Block"
import Photo from "../elements/Photo"
import Gif from "../elements/Gif"
import Tags from "../elements/Tags"

import event_1 from "../../images/events/september/event-1.gif"

const Grid = styled.div`
  display: grid;
  grid-gap: var(--gutter-l);
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: auto auto auto auto auto;
  grid-template-areas: ". event-1 event-1 event-1" "event-2 event-2 event-2 ." ". event-3 event-3 event-3" ". event-4 event-4 event-4" "culture-1 culture-1 . ." ". . culture-2 culture-2";
  .event-1 {
    grid-area: event-1;
  }
  .event-2 {
    grid-area: event-2;
  }
  .event-3 {
    grid-area: event-3;
  }
  .event-4 {
    grid-area: event-4;
  }
  .culture-1 {
    grid-area: culture-1;
  }
  .culture-2 {
    grid-area: culture-2;
  }
  @media (min-width: 768px) {
  }
  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: auto auto auto auto auto;
    grid-template-areas: ". event-1 event-1 ." ". . event-2 event-2" "event-3 event-3 event-2 event-2" " event-3 event-3 event-4 event-4" ". . event-4 event-4" ". culture-1 . ." ". culture-1 culture-2 ." ". . culture-2 .";
  }
  @media (min-width: 1200px) {
  }
`

const September = () => {
  const data = useStaticQuery(graphql`
    query {
      septemberEventTwo: file(
        relativePath: { eq: "events/september/event-2.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 800, maxHeight: 599, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      septemberEventThree: file(
        relativePath: { eq: "events/september/event-3.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 800, maxHeight: 600, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      septemberEventFour: file(
        relativePath: { eq: "events/september/event-4.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 800, maxHeight: 533, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      septemberCultureOne: file(
        relativePath: { eq: "events/september/culture-1.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 600, maxHeight: 783, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      septemberCultureTwo: file(
        relativePath: { eq: "events/september/culture-2.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 400, maxHeight: 522, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <Month name="september">
      <Grid>
        <Block className="event-1">
          <Gif src={event_1} maxWidth={400} maxHeight={400} />
          <h4 style={{ maxWidth: 400 }}>
            Teamgeek turned Seven! Happy Birthday to Us.
          </h4>
        </Block>

        <Block className="event-2">
          <Photo img={data.septemberEventTwo} maxWidth={800} maxHeight={599} />
          <h4 style={{ maxWidth: 800 }}>
            We wrapped up the prototype app for an African audiobook startup
            called Bib.
          </h4>
          <Tags maxWidth={800} words={["inVision", "react", "reactnative"]} />
        </Block>

        <Block className="event-3">
          <Photo
            img={data.septemberEventThree}
            maxWidth={800}
            maxHeight={600}
          />
          <h4 style={{ maxWidth: 800 }}>
            We played around with light and dark modes.
          </h4>
        </Block>

        <Block className="event-4">
          <Photo img={data.septemberEventFour} maxWidth={800} maxHeight={533} />
          <h4 style={{ maxWidth: 800 }}>
            Teamgeek launched the website of a small-business-lending{" "}
            <a
              href="https://getbackd.com/"
              rel="noreferrer noopener"
              target="_blank"
              className="mouse-link"
            >
              company
            </a>{" "}
            in Austin, Texas.
          </h4>
          <Tags
            maxWidth={800}
            words={["inVision", "react", "gatsbyjs", "graphql", "serverless"]}
          />
        </Block>
        <Block className="culture-1">
          <Photo
            img={data.septemberCultureOne}
            maxWidth={600}
            maxHeight={783}
          />
          <h4 style={{ maxWidth: 600 }}>
            Johnny joined the gang as an Account Manager.
          </h4>
        </Block>
        <Block className="culture-2">
          <Photo
            img={data.septemberCultureTwo}
            maxWidth={400}
            maxHeight={522}
          />
          <h4 style={{ maxWidth: 400 }}>
            Daniel, our animator at Teamgeek, turned a year older.
          </h4>
        </Block>
      </Grid>
    </Month>
  )
}

export default September
